import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import {closeOutsourceContractApi, closeContractApi} from '../service'
export default {
    data() {
        return {
            show:false,
            saving:false,
            params: {
                id: '',
                is_finish: false,
                expect_finish_date: '',
                type:1,
                memo: ''
            },
            expect_finish_date: null,
            is_stock: false,
        }
    },
    computed: {
        job_dis() {
            if (this.is_stock) {
              return '财务核算【Givenchy】'
            }
            return '财务核算【Gucci】'
          },
        fields() {
            return [
                {
                    label: '合同预计完结时间',
                    key:'expect_finish_date',
                    type:'date_picker_v1',
                    required: true,
                    allowedDates: (val) => {
                       if (val > this.params.inventory_end) {
                        return false
                       }
                       return true
                    },
                    cols: 12,
                    rules:[val => {
                      return !!val || '必选'
                    },
                    val => {
                        if (val && val > this.expect_finish_date) {
                            return `预计完结时间不能大于合同约定时间（${this.expect_finish_date}），有任何疑问请及时联系${this.job_dis}`
                        }
                        return true
                    }
                ],
                },
                {
                    label: '未完结理由',
                    key:'memo',
                    type:'textareas_field',
                    required: true,
                    rows: 4,
                    cols: 12,
                    counter: 128,
                    rules:[val => {
                        if (!val) {
                            return '必选'
                        }
                        if (!!val && val.length > 128) {
                            return '不能超过128个字符'
                        }
                      return true
                    }],
                },
            ]
        }
    },
    methods: {
        edit(data) {
            this.show = true
            this.params.is_finish = false
            this.params.expect_finish_date = data.expect_finish_date
            this.expect_finish_date = data.expect_finish_date
            this.is_stock = data.is_stock
            this.params.type = data.type
            this.params.memo = ''
            this.params.id = data.id
            setTimeout(() => {
                this.$refs.form && this.$refs.form.resetValidation()
            }, 50)
        },
        submit() {
            if (this.$refs.form.validate()) {
                let f = null
                switch (this.params.type) {
                  case 1:
                  case 2:
                    f = closeContractApi
                    break;
                    case 3:
                    f = closeOutsourceContractApi
                      break;
                  default:
                    break;
                }
                if (!f) {
                  
                  return    
                }
                this.saving = true
                f(this.params).then(() => {
                  this.$Message.success('未完结成功！')
                  this.$emit('success')
                  this.show = false
                }).finally(() => {
                    this.saving = false
                })
            }
        }
    },
    render() {
        return <VModal
        v-model={this.show}
        dynamicHeight
        heightRate={0.6}
        title="未完结"
        loading={this.saving}
        width={500}
        ref="modal"
        ok-text="保存"
        on={{
            ok: () => {
                this.submit() 
            },
        }}
        >
            <VForm 
                ref="form" 
                fields={this.fields} 
                v-model={this.params}
                
            />
        </VModal>
    }
}